export default __webpack_public_path__ + "static/media/0x568d925774be9967F23d7e878A6692068de569E2.f580eef9.svg";